<template>
  <div class="apply-return">
    <div
      class="goodsStyle acea-row row-between"
      v-for="cart in orderInfo.cartInfo"
      :key="cart.id"
    >
      <div class="pictrue">
        <img :src="cart.productInfo.image" class="image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">{{ cart.productInfo.storeName }}</div>
        <div class="money">
          <div>
            {{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
            <span class="integral">积分</span>
          </div>
          <div class="num">x{{ cart.cartNum }}</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>退货件数</div>
        <div class="num">{{ orderInfo.totalNum }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款金额</div>
        <div class="num">
          {{ orderInfo.payPrice }}<span class="integral">积分</span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>退款原因</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">选择退款原因</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text"
              :key="index"
            >
              {{ text }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <div class="item textarea acea-row row-between">
        <div>
          备注说明<br /><span class="xianzhi"
            >(还可以输入{{ 100 - refund_reason_wap_explain.length }}个字)</span
          >
        </div>
        <textarea
          placeholder="填写备注信息，100字以内"
          class="num"
          v-model="refund_reason_wap_explain"
          :maxlength="100"
        ></textarea>
      </div>
    </div>

    <div class="evaluate-con">
      <div class="score">
        <div class="textarea">
          <div class="list acea-row row-middle">
            <div
              class="pictrue"
              v-for="(item, index) in refund_reason_wap_img"
              :key="index"
            >
              <img :src="item" />
              <span
                class="iconfont icon-guanbi1 font-color-red"
                @click="refund_reason_wap_img.splice(index, 1)"
              ></span>
            </div>
            <VueCoreImageUpload
              class="btn btn-primary"
              :crop="false"
              compress="80"
              @imageuploaded="imageuploaded"
              @errorhandle="errorhandle"
              :headers="headers"
              :max-file-size="5242880"
              :credentials="false"
              inputAccept="image/*"
              inputOfFile="file"
              :url="url"
              v-if="refund_reason_wap_img.length < 8"
            >
              <div
                class="pictrue uploadBnt acea-row row-center-wrapper row-column"
              >
                <span class="iconfont icon-icon25201"></span>
                <div>上传图片</div>
              </div>
            </VueCoreImageUpload>
          </div>
        </div>
      </div>
    </div>

    <div class="returnBnt bg-color-red" @click="submit">申请退款</div>
  </div>
</template>
<style scoped>
.evaluate-con .score .textarea .list .pictrue.uploadBnt {
  border: 1px solid #ddd;
}
</style>

<script>
import { orderDetail, getRefundReason, postOrderRefund } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "goodsReturn",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      // url: `https://api.dayandt.com/api/image/upload`,
      url: `${VUE_APP_API_URL}/image/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      orderInfo: {},
      reasonList: [],
      reason: "",
      type: 0,
      refund_reason_wap_explain: "",
      refund_reason_wap_img: []
    };
  },
  methods: {
    imageuploaded(res) {
      // if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.link);
    },
    errorhandle(res) {
      if (res === "FILE IS TOO LARGER MAX FILE IS 5.00MB")
        this.$dialog.error("文件大小超过5.00M");
    },
    getOrderDetail() {
      orderDetail(this.id)
        .then(res => {
          this.orderInfo = res.data;
          if (
            this.orderInfo.status === 1 ||
            this.orderInfo.status === 2 ||
            this.orderInfo.status === 3
          ) {
            this.type = 1;
          }

          getRefundReason(this.type).then(res => {
            this.reasonList = res.data;
          });
        })
        .catch(err => {
          this.$dialog.error(err.msg || "获取订单失败");
        });
    },
    getRefundReason() {
      getRefundReason(this.type).then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
      const refund_reason_wap_explain = trim(this.refund_reason_wap_explain),
        text = this.reason;

      // if (text !== "不喜欢/不合适" && this.refund_reason_wap_img.length === 0)
      //   return this.$dialog.toast({ mes: "请上传图片" });
      if (!text) return this.$dialog.toast({ mes: "请选择退款原因" });
      postOrderRefund({
        text,
        uni: this.orderInfo.orderId,
        refund_reason_wap_img: this.refund_reason_wap_img.join(","),
        refund_reason_wap_explain
      })
        .then(res => {
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  },
  mounted() {
    this.getOrderDetail();
    // this.getRefundReason();
  }
};
</script>
